module.exports = __webpack_public_path__ + "img/mba-andrea.ac9ce77a.jpg";